<template>
  <div>
    <i-button v-if="list.length === 0"
              html-type="button"
              @click="add(-1)"
              style="width: 100%">{{$t('pages_combo_rule_list_290')}}</i-button>
    <div class="rule-item"
         v-for="(item, index) in list"
         :key="index">
      <span class="prefix">{{$t('pages_enough_consume_discount_rule_list_489')}}</span>
      <i-input :value="item.enough"
               @on-change="(e) => changeEnough(e, index)" />{{$t('pages_enough_consume_discount_rule_list_490')}}<span class="prefix">{{ category === $t('pages_combo_index_286') ? $t('pages_enough_consume_discount_rule_list_491') : $t('pages_enough_consume_discount_rule_list_492')}}</span>
      <i-input :value="item.cut"
               @on-change="(e) => changeCut(e, index)" /> <span class="suffix">{{ category === $t('pages_combo_index_286') ? $t('pages_enough_consume_discount_rule_list_493') : $t('pages_enough_consume_discount_rule_list_494') }}，</span>
      <span class="handlers">
        <a v-if="list.length < 5"
           @click.prevent="add(index)">{{$t('pages_combo_rule_list_290')}}</a>
        <a type="text"
           @click.prevent="remove(index)"
           style="margin-left: 8px">{{$t('libs_table_render_70')}}</a>
      </span>
    </div>
  </div>
</template>

<script>
import i18n from '../../locales/index'

export default {
  props: ['value', 'category'],
  computed: {
    list () {
      return this.value || [];
    }
  },
  methods: {
    changeEnough (e, index) {
      const copy = this.value.slice();
      copy[index] = {
        ...copy[index],
        enough: parseInt(e.target.value) || '',
      }
      this.$emit('input', copy)
    },
    changeCut (e, index) {
      const copy = this.value ? this.value.slice() : [];
      copy[index] = {
        ...copy[index],
        cut: parseInt(e.target.value) || '',
      }
      this.$emit('input', copy)
    },
    add (index) {
      const copy = this.value ? this.value.slice() : [];
      copy.splice(index + 1, 0, { enough: 0, cut: 0 })
      this.$emit('input', copy)
    },
    remove (index) {
      const copy = this.value ? this.value.slice() : [];
      copy.splice(index, 1)
      this.$emit('input', copy)
    },
  }
}
</script>

<style lang="scss" scoped>
.rule-item {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  div {
    margin-right: 5px;
  }
  > span {
    &.prefix {
      flex: 0 0 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &.suffix {
      flex: 0 0 80px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &.handlers {
      flex: 0 0 100px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
